/* globals lp,  editor */
var jQuery = require('jquery');
var _ = require('lodash');

var mod = lp.module;

var _elmToTypeMapping = function() {
  return {
    root: mod.root.RootElement.prototype.type,
    block: mod.block.SectionElement.prototype.type,
    box: mod.box.BoxElement.prototype.type,
    text: mod.text.TextElement.prototype.type,
    image: mod.image.ImageElement.prototype.type,
    button: mod.button.ButtonElement.prototype.type,
    form: mod.form.FormElement.prototype.type,
    video: mod.video.VideoElement.prototype.type,
    code: mod.code.CustomHTMLElement.prototype.type,
    social_widget: mod.socialWidget.SocialWidgetElement.prototype.type,
    multi_select: mod.multiSelect.MultiSelectElement.prototype.type
  };
};

var _elmToSelector = function(name) {
    var mappings = _elmToTypeMapping();
    var cssClassName;
  if (mappings.hasOwnProperty(name)) {
    cssClassName = mappings[name];
  } else {
    cssClassName = _.contains(_.values(mappings), name) ? name : '';
  }
  return '.' + cssClassName;
};

var _panelSelectorMapping = {
  contentTree: "#page-content-panel",
    main: "#editor-canvas #page-body",
  widget: "#component-side-bar",
  properties: "#editor-info-panel .element-properties-panel"
};

var _hasElementInPanel = function(elmName, panelType) {
  var panelSelector = _panelSelectorMapping[panelType];

  return ! _.isEmpty(jQuery(panelSelector).find(_elmToSelector(elmName)));
};

var _hasElementInPOM = function(elmName) {
  return !_.isEmpty(editor.page.getElementsByType(_elmToTypeMapping()[elmName]));
};

var _getPOMElementsByName = function(name) {
  return editor.page.getElementsByType(_elmToTypeMapping()[name]);
};

var _isPropertiesTabEnabled = function(num) {
  // num:
  //  0: Properties
  //  1: Page Properties
  //  2: Conversion Goals
  return jQuery('#editor-info-panel .tab-bar')
    .not('#editor-info-panel .view-pane .tab-bar') // Avoid other tab bars in panels
    .find('a.tab')
    .eq(num)
    .hasClass('on');
};

var _isNonRootElementSelectedAndPropertiesPanelVisible = function() {
  var _isVisibleAndPropertiesTabIsEnabled = function() {
      return (editor.activeElement.isVisibleOnPage() && _isPropertiesTabEnabled(0));
  };

  return editor.activeElement.id !== "lp-pom-root" &&
    _isVisibleAndPropertiesTabIsEnabled();
};

var _isPagePropertiesTabEnabled = function() {
  return _isPropertiesTabEnabled(1);
};

var _isElementBeingDragged = function() {
  return jQuery('#dummy-section').length > 0 ||
    jQuery('.dnd-shield').length > 0 ||
    jQuery('.dnd-ghost').length > 0;
};

module.exports = {
  elmToTypeMapping: _elmToTypeMapping,
  elmToSelector: _elmToSelector,
  panelSelectorMapping: _panelSelectorMapping,
  hasElementInPanel: _hasElementInPanel,
  hasElementInPOM: _hasElementInPOM,
  getPOMElementsByName: _getPOMElementsByName,
  isPropertiesTabEnabled: _isPropertiesTabEnabled,
  isNonRootElementSelectedAndPropertiesPanelVisible: _isNonRootElementSelectedAndPropertiesPanelVisible,
  isPagePropertiesTabEnabled: _isPagePropertiesTabEnabled,
  isElementBeingDragged: _isElementBeingDragged
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/invariants/invariants-helper.js
// module id = 71
// module chunks = 0